import React from "react";

export function PageHeader({ title, subtitle, actions, testId }) {
  return (
    <div className="flex items-start justify-between flex-wrap gap-4 pb-6 border-b border-[#E5E2DC] mb-6" data-testid={testId}>
      <div>
        <h1 className="heading text-3xl md:text-4xl">{title}</h1>
        {subtitle && <p className="text-sm text-[#5e675e] mt-1 max-w-xl">{subtitle}</p>}
      </div>
      {actions && <div className="flex gap-2">{actions}</div>}
    </div>
  );
}

export function Stat({ label, value, unit, hint, tone = "default", testId }) {
  const tones = {
    default: "bg-white border-[#E5E2DC]",
    accent:  "bg-[#1A1D1A] text-white border-[#1A1D1A]",
    warn:    "bg-[#C45B45] text-white border-[#C45B45]",
    ok:      "bg-[#2D4A36] text-white border-[#2D4A36]",
  };
  return (
    <div className={`border ${tones[tone]} rounded-md p-5`} data-testid={testId}>
      <div className={`text-[11px] uppercase tracking-widest ${tone === "default" ? "text-[#8a938c]" : "text-white/70"}`}>{label}</div>
      <div className="stat-num text-3xl md:text-4xl mt-2">{value}<span className="text-lg ml-1 opacity-70">{unit}</span></div>
      {hint && <div className={`text-xs mt-2 ${tone === "default" ? "text-[#8a938c]" : "text-white/70"}`}>{hint}</div>}
    </div>
  );
}

export function Card({ children, className = "", testId, ...rest }) {
  const dataTestId = testId || rest["data-testid"];
  const { "data-testid": _dt, ...forwardable } = rest;
  return (
    <div className={`card-flat p-5 ${className}`} data-testid={dataTestId} {...forwardable}>{children}</div>
  );
}

export function Button({ children, variant = "primary", className = "", ...rest }) {
  const styles = {
    primary: "bg-[#1A1D1A] text-white hover:bg-[#2D4A36]",
    secondary: "bg-white border border-[#E5E2DC] hover:bg-[#F7F6F3] text-[#1A1D1A]",
    accent: "bg-[#C45B45] text-white hover:bg-[#a94a37]",
    ghost: "bg-transparent hover:bg-[#F0EEE8] text-[#1A1D1A]",
    danger: "bg-white border border-[#f2d4cb] text-[#C45B45] hover:bg-[#fbeee9]",
  };
  return (
    <button className={`px-4 py-2.5 rounded-md text-sm font-semibold ${styles[variant]} ${className}`} {...rest}>
      {children}
    </button>
  );
}

export function Input(props) {
  return <input {...props} className={`w-full px-3 py-2.5 border border-[#E5E2DC] rounded-md text-sm bg-white outline-none focus:border-[#2D4A36] ${props.className || ""}`} />;
}

export function Select({ children, ...props }) {
  return <select {...props} className={`w-full px-3 py-2.5 border border-[#E5E2DC] rounded-md text-sm bg-white outline-none focus:border-[#2D4A36] ${props.className || ""}`}>{children}</select>;
}

export function Textarea(props) {
  return <textarea {...props} className={`w-full px-3 py-2.5 border border-[#E5E2DC] rounded-md text-sm bg-white outline-none focus:border-[#2D4A36] ${props.className || ""}`} />;
}

export function Field({ label, children }) {
  return (
    <label className="block">
      <div className="text-[11px] uppercase tracking-widest text-[#6b746c] mb-1.5 font-semibold">{label}</div>
      {children}
    </label>
  );
}

export function StatusBadge({ status }) {
  const map = {
    "sağlıklı": ["#2D4A36", "#E4EEE6"],
    "hasta": ["#C45B45", "#FBE9E4"],
    "gebe": ["#8B6914", "#F7EBCC"],
    "kuruda": ["#5A6E5F", "#E7EBE7"],
    "buzağı": ["#417251", "#DFEAE2"],
    "satıldı": ["#8a938c", "#EEEEEB"],
    "gelir": ["#2D4A36", "#E4EEE6"],
    "gider": ["#C45B45", "#FBE9E4"],
    "iyileşti": ["#2D4A36", "#E4EEE6"],
    "vefat": ["#8a938c", "#EEEEEB"],
    "tedavi görüyor": ["#8B6914", "#F7EBCC"],
    "boş": ["#8a938c", "#EEEEEB"],
    "şüpheli": ["#8B6914", "#F7EBCC"],
  };
  const [fg, bg] = map[status] || ["#1A1D1A", "#EEECE5"];
  return <span className="inline-block px-2 py-0.5 rounded-full text-xs font-medium" style={{ color: fg, background: bg }}>{status}</span>;
}
